const componentSizes = ["", "default", "small", "large"];
const componentSizeMap = {
  large: 40,
  default: 32,
  small: 24
};

export { componentSizeMap, componentSizes };
//# sourceMappingURL=size2.mjs.map
